import axios from 'axios';
import xml2js from 'xml2js';

export const fetchTypeAheadQuery = (serviceUrl, queryParams) =>
  axios
    .get(serviceUrl, {
      params: {
        JSIN: 1,
        AUTO_COMPLETE: 1,
        CheckAdditionalCondition: true,
        FAQ: 0,
        ...queryParams,
      },
      withCredentials: true,
    })
    .then((res) => {
      return new Promise((resolve, reject) => {
        const parser = new xml2js.Parser();

        parser.parseString(
          res.data ?? `<AutoCompleteInfo></AutoCompleteInfo>`,
          (err, result) => {
            if (err) {
              reject(err);
            }

            const {
              AutoCompleteInfo: { AutoComplete },
            } = result;

            resolve(AutoComplete?.slice(0, 3) ?? []);
          },
        );
      });
    });
